import {
  breakpointSizes,
  getBreakpointDown,
  getBreakpointUp,
  getFontCss,
  styleConstants,
} from '@paywithextend/components'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import HoverTooltip from 'src/components/HoverTooltip/HoverTooltip'
import Trns from 'src/localization/Trns'
import { OrganizationIntegrationListModel } from 'src/models/organizationIntegration.models'
import { selectFormattedOrgIntegrationLastSyncDate } from 'src/redux/selectors/data/orgIntegrations.selectors'
import { css } from 'styled-components'

interface ConfirmationPopupContentProps {
  activeIntegration: OrganizationIntegrationListModel
}

const ConnectedToERP: React.FC<ConfirmationPopupContentProps> = (
  props,
): React.ReactElement => {
  const lastSyncDate = useSelector(selectFormattedOrgIntegrationLastSyncDate)
  const [hover, setHover] = useState<boolean>(false)

  const image = (
    <img
      css={css`
        width: 20px;
        height: 20px;
      `}
      src={props.activeIntegration.logo}
      alt={''}
    />
  )

  return (
    <div
      css={css`
        display: flex;
        ${getFontCss(
          14,
          styleConstants.colors.gray_darkest,
          styleConstants.fontFamilies.medium,
        )};
      `}
    >
      <div
        css={css`
          position: relative;
          display: flex;
          height: fit-content;

          ${getBreakpointUp(breakpointSizes.SM)(css`
            display: none;
          `)}
        `}
        onMouseEnter={(): void => setHover(true)}
        onMouseLeave={(): void => setHover(false)}
      >
        {image}
        <HoverTooltip
          show={hover}
          css={css`
            ${getFontCss(
              12,
              styleConstants.colors.white,
              styleConstants.fontFamilies.medium,
            )};
            text-align: left;
            padding: 12px;
            transform: translate(-87.5%);

            &::after {
              left: 90%;
            }
          `}
          tooltipText={
            <Trns
              source={
                'Expense Categories from ${integration} last refreshed on ${date}'
              }
              expressions={{
                date: lastSyncDate,
                integration: props.activeIntegration.platformName,
              }}
            />
          }
        />
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          white-space: nowrap;
          gap: 4px;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            display: none;
          `)}
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: row;
            gap: 4px;
          `}
        >
          <Trns
            source={'Connected to ${connection}'}
            expressions={{ connection: props.activeIntegration.platformName }}
          />
          {image}
        </div>
        <div
          css={css`
            ${getFontCss(
              12,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          <Trns
            source={'Last refreshed ${date}'}
            expressions={{
              date: lastSyncDate,
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ConnectedToERP
